import { loadScript } from '../loadScript';

export async function loadFotorama(): Promise<void> {
  if (window.fotoramaVersion) {
    return;
  }

  await loadScript('//www.cian.ru/static/scripts/jquery-1.11.1.min.js');
  await loadScript('//www.cian.ru/static/scripts/fotorama_4.6.4.1.js');
}
